import { Icon } from '@circlefin/components'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'

export type CopyHelpText = {
  /**
   * Whether the link has been copied.
   */
  isCopied: boolean
}

export const CopyHelpText: React.FC<CopyHelpText> = ({ isCopied }) => {
  const { t } = useTranslation('common')

  return (
    <p
      className={classNames(
        // by default, the text is not visible. Group hover will make it visible.
        // isCopied will make it visible regardless of group hover.
        'type-body-base-bold text-neutral-subtlest group-hover:cursor-pointer group-hover:visible',
        {
          invisible: !isCopied,
          visible: isCopied,
        },
      )}
      data-testid="copy-help-text"
    >
      {isCopied ? (
        <>{t`anchorHeading.copied`}</>
      ) : (
        <span className="flex items-center gap-[2px]">
          <Icon name="LinkOutline" size={20} />
          {t`anchorHeading.copyLink`}
        </span>
      )}
    </p>
  )
}
